export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq3b-ThirdParty-Blank.eae9091a.png";